module.exports = __webpack_public_path__ + "img/custom2.392ccaa2.png";